/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8f478d3fb4a28827bd16197b46ea0ac>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { ChatNewLogo } from './logo';
export { ChatNewLogoCS } from './logo-cs';
export { ChatNewIcon } from './icon';
